import { Box, List, ListItem, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import PlaylistCard from './PlaylistCard'


const Playlist = (props) => {
    const { album, setAudioObj, audioObj, playAudio, playAlbum, setPlayAlbum,
        setPlayAudio, toggleAudio, colors, setTrkNum, albums, listEmail,
        currentTime, setTimestamp, setCommentModalOpen, onSeek,
        setShopModalOpen, showLyrics, setShowLyrics,
        selectedLyrics, setSelectedLyrics,
        duration, listener, setListener, setShareModalOpen, shareModalOpen,
        trkNum, albumNav, setAlbumNav, saveListen, rankedTracks } = props
    // const [showLyrics, setShowLyrics] = useState(false)
    // const [selectedLyrics, setSelectedLyrics] = useState()
    //             useEffect (()=>{

    //     console.log('playAudio:', playAudio)
    //   },[playAlbum, playAudio])
    return (
        // <List sx={{}}>
        <List sx={{ position: 'relative', overflow: 'hidden', overflowY: 'scroll', }}>

            {album && album?.tracks?.map((item, i) => {
                return (
                    // <ListItem key={'playlistCard' + i}>
                    <PlaylistCard item={item} key={'playlistCard' + i} index={i}
                        setAudioObj={setAudioObj}
                        saveListen={saveListen}
                        duration={duration}
                        albums={albums}
                        audioObj={audioObj}
                        setPlayAudio={setPlayAudio}
                        playAudio={playAudio}
                        setPlayAlbum={setPlayAlbum}
                        playAlbum={playAlbum}
                        toggleAudio={toggleAudio}
                        setTrkNum={setTrkNum}
                        trkNum={trkNum}
                        albumNav={albumNav}
                        listEmail={listEmail}
                        setAlbumNav={setAlbumNav}
                        colors={colors}
                        listener={listener}
                        setListener={setListener}
                        setShareModalOpen={setShareModalOpen}
                        shareModalOpen={shareModalOpen}
                        setTimestamp={setTimestamp}
                        setCommentModalOpen={setCommentModalOpen}
                        currentTime={currentTime}
                        onSeek={onSeek}
                        rankedTracks={rankedTracks}
                        setShopModalOpen={setShopModalOpen}
                        showLyrics={showLyrics}
                        setShowLyrics={setShowLyrics}
                        selectedLyrics={selectedLyrics}
                        setSelectedLyrics={setSelectedLyrics}

                        style={{
                            padding: '0.5rem',


                        }}
                        onClick={(e) => {

                            setAudioObj({
                                ...item,
                                id: i
                            })
                            // console.log('current audio:',audioObj)
                        }}
                    />
                    // </ListItem>
                )
            })

            }
            <Box sx={{ height: '10rem' }}>

            </Box>
        </List>
    )
}

export default Playlist